// ****************************************************************************************************************************************************
// Function to customize search button

export function customizeSearch() {
  $('.header .searchSubmitButton').attr('tabindex', '-1');

  const input = $('.header .inputFieldTextbox');
  const defaultText = 'Search Website';

  input.on('focus', function () {
    if ($(this).val() === defaultText) {
      $(this).val('');
    }
  });

  input.on('blur', function () {
    if ($(this).val().trim() === '') {
      $(this).val(defaultText);
    }
  });
}

// ****************************************************************************************************************************************************
// Utility function to create custom burger toggle button

export function createCustomToggle() {
  const currentToggle = $(`.mobile-nav-toggle`);
  const closeToggle = $('.mobile-menu-container .close-mobile-menu');

  updateToggle();
  openMenuKeyboard();

  function updateToggle() {
    currentToggle.attr('tabindex', '0');
    for (let i = 0; i < 3; i++) {
      currentToggle.append("<span class='toggle-line'></span>");
    }
  }

  function openMenuKeyboard() {
    currentToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && !$('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
        closeMenuKeyboard();
      }
    });
  }

  function closeMenuKeyboard() {
    closeToggle.attr('tabindex', '0');
    closeToggle.focus();

    closeToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && $('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
      }
      currentToggle.focus();
    });
  }
}

// ****************************************************************************************************************************************************
// Function to set the header logo link URL

export function logosURL(themeData) {
  const activeTheme = themeData.find((theme) => $('body').hasClass(theme.classBody));

  activeTheme &&
    $('.header-logo').attr('href', activeTheme.link).attr('aria-label', activeTheme.name);
}

// ****************************************************************************************************************************************************
//  Checks if the body has a specific class name

export const isPage = (className) => $('body').hasClass(className);

// ****************************************************************************************************************************************************

// Session storage used to persist subtheme
export const storage = globalThis.sessionStorage;

// Current URL path used to detect active theme
export const location = globalThis.location.pathname;

// ****************************************************************************************************************************************************
// Stores subtheme in session storage

export function applyThemeClass(theme) {
  storage.setItem('subTheme', true);
  storage.setItem('subThemeName', theme);
}

// ****************************************************************************************************************************************************
// Applies stored subtheme class to body based on current URL

export function applySubthemeClass(themeData) {
  const currentTheme = themeData.find((theme) => location.startsWith(new URL(theme.link).pathname));

  if (currentTheme) {
    $('body').addClass(currentTheme.classBody);
  } else {
    const storedTheme = storage.getItem('subThemeName');

    if (storedTheme) {
      $('body').addClass(storedTheme);
    }
  }
}

// ****************************************************************************************************************************************************
// Utility to move theme widgets before the main content

export function moveWidgetsToMainContent(themeData) {
  const currentTheme = themeData.find((theme) => isPage(theme.classLanding));

  if (!currentTheme) return;

  const subthemeWidgetsContainer = $(`#${currentTheme.widgetContainer}`);

  const subthemeWidgets = subthemeWidgetsContainer.children();
  const content = $('.content');
  content.append(subthemeWidgets);
  $(`#${currentTheme.widgetContainer}`).empty();
}

// ****************************************************************************************************************************************************
// Utility function to clean main content

export function cleanContent() {
  $('body .content').empty();
}

// ****************************************************************************************************************************************************
// Validates if subtheme

export function validateSubtheme(themeData) {
  const isSubtheme = themeData.find(
    (subtheme) => subtheme.classBody && $('body').hasClass(subtheme.classBody),
  );

  return isSubtheme?.classBody || false;
}

// ****************************************************************************************************************************************************
// Funtion to add a new custom item on the mobile menu

export function addMobileItem({ wrapperClass, linkClass, linkUrl, linkLabel }) {
  const mobileContainer = $('.mobile-menu-slider');

  const $wrapper = $('<div>', {
    class: wrapperClass,
  });

  const $a = $('<a>', {
    class: linkClass,
    href: linkUrl,
    text: linkLabel,
  });

  $wrapper.append($a);
  $wrapper.insertBefore(mobileContainer);
}

// ****************************************************************************************************************************************************
// Funtion to validate window size based on a breakpoint value

export function getWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}
